import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip, Grid } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import * as TableFilterActions from 'main/components/tableFilter/store/actions';
import { withRouter } from 'react-router-dom';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers';
import PageHeader from 'main/components/PageHeader';
import TableFilter from 'main/components/tableFilter/TableFilter';

const styles = theme => ({
    layoutRoot: {},
});

class QuizList extends Component {

    constructor(props) {
        super(props);
        this.props.getQuizList('list');
    }

    componentWillUnmount = () => {
        this.props.setTableFilter(this.props.auth.user.data.auth_id, 'QuizList', this.props.filterList.filterColumns);
        this.props.clearFilterStore();
    }

    handleRowClick(page_type, quiz_id) {
        this.props.history.push(`/quiz/${page_type}/${quiz_id}`);
    }

    checkLockPermission = (row) => {
        const auth_id = this.props.auth.user.data.auth_id;
        const role = this.props.auth.user.role;
        if (row.IsLocked === 0) {
            return true
        }
        else {
            if (role === 'dev' || role === 'admin' || role === 'company') {
                return true
            }
            else if (role === 'instructor' && row.LockedByAuthID === auth_id) {
                return true
            }
        }
        return false
    }

    checkFilterValueSaved = (column) => {
        const { table_filter } = this.props
        if (!table_filter['QuizList']) {
            return false
        }
        if (!table_filter['QuizList'].find(col => col.id === column)) {
            return false
        }

        else {
            return table_filter['QuizList'].find(col => col.id === column).value.filterValue
        }
    }

    getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
            if (rowInfo.original.Active === 0) {
                return {
                    style: {
                        background: '#a85e59'
                    } 
                }
            }
        }
        return {};
    }

    editAllow = (row) => {
        if (this.checkLockPermission(row)) {
            let tooltipContent = 'Edit';
            if (row.IsLocked === 1) {
                tooltipContent = <React.Fragment><div>Edit</div><div>(Locked)</div></React.Fragment>
            }
            return (
                <Tooltip title={tooltipContent}>
                    <IconButton
                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                        onClick={(ev) => {
                            ev.stopPropagation();
                            this.handleRowClick('edit', row.quiz_id);
                        }}
                    >
                        <Icon>border_color</Icon>
                    </IconButton>
                </Tooltip>
            )
        }
        else {
            return (
                <Tooltip title="This quiz is locked">
                    <Icon style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }} >lock</Icon>
                </Tooltip>
            )
        }

    }

    render() {
        const { classes, quizList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;
        if (!is_loaded || !this.props.quizListLoadedAfterSave || !this.props.listLoaded) return <React.Fragment>Loading...</React.Fragment>;
        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <PageHeader
                        component_type={"quiz"}
                        view_type={"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name={"quiz"}
                            view_type={"list"}
                            button_list={[
                                {
                                    display: "Add",
                                    type: "create",
                                    color: "primary",
                                    onClick: () => this.props.history.push("/quiz/create"),
                                }
                            ]}
                        />
                    </div>
                }
                content={
                    <Grid container style={{ height: '100%' }}>
                        <Grid item xs={9}>
                            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                                <ReactTable
                                    style={{ position: 'absolute' }}
                                    columns={[
                                        {
                                            Header: "Quiz Name",
                                            accessor: "QuizName",
                                            Cell: row => (
                                                <TableCellTooltip
                                                    item={row.original.QuizName}
                                                    chars={20}
                                                />
                                            )
                                        },
                                        {
                                            Header: "Quiz Description",
                                            accessor: "QuizDescription",
                                            Cell: row => (
                                                <TableCellTooltip
                                                    item={row.original.QuizDescription}
                                                    chars={20}
                                                />
                                            )
                                        },
                                        {
                                            Header: "Total Score",
                                            // accessor: "TotalScore",
                                            maxWidth: 100,
                                            Cell: row => (
                                                Number(row.original.TotalScore).toFixed(1)
                                            )
                                        },
                                        {
                                            Header: "Max Attempts",
                                            accessor: "MaxAttempt",
                                            maxWidth: 100,
                                        },
                                        {
                                            Header: "Time Limit",
                                            accessor: "TimeLimit",
                                            maxWidth: 100,
                                        },
                                        {
                                            Header: "Actions",
                                            maxWidth: 100,
                                            Cell: row => (
                                                <div className="flex items-center">
                                                    <Tooltip title="Detail">
                                                        <IconButton
                                                            style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                            onClick={(ev) => {
                                                                ev.stopPropagation();
                                                                this.handleRowClick('detail', row.original.quiz_id);
                                                            }}
                                                        >
                                                            <Icon>library_books</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                    {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "quiz", "edit") ? null :
                                                        this.editAllow(row.original)
                                                    }
                                                </div>
                                            ),
                                        }
                                    ]}
                                    data={this.props.filterList.filteredDataList}
                                    defaultPageSize={25}
                                    pageSize={table_page_size[table_name]}
                                    className="-striped -highlight"
                                    noDataText="No Quizs Found"
                                    defaultSorted={table_sort[table_name]}
                                    onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                                    filterable={false}
                                    onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                                    getTrProps={this.getTrProps}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={3} style={{ overflowY: 'auto', width: '100%', overflowX: 'hidden' }}>
                            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                                <TableFilter
                                    componentName={'QuizList'}
                                    defaultList={quizList}
                                    preloadValues={table_filter['QuizList'] ? true : false}
                                    columns={[
                                        {
                                            columnName: 'Quiz Name',
                                            column_id: 'QuizName',
                                            columnType: 'string',
                                            filterType: 'string_contains',
                                            value: this.checkFilterValueSaved('QuizName') || '',
                                            active: this.checkFilterValueSaved('QuizName') ? true : false
                                        },
                                        {
                                            columnName: 'Quiz Description',
                                            column_id: 'QuizDescription',
                                            columnType: 'string',
                                            filterType: 'string_contains',
                                            value: this.checkFilterValueSaved('QuizDescription') || '',
                                            active: this.checkFilterValueSaved('QuizDescription') ? true : false
                                        },
                                        {
                                            columnName: 'Active',
                                            column_id: 'Active',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            value: this.checkFilterValueSaved('Active') ? Number(this.checkFilterValueSaved('Active')) : 2,
                                            // active: Number(this.checkFilterValueSaved('Active')) !== 0,
                                            active: true
                                        },
                                        {
                                            columnName: 'On Calendar',
                                            column_id: 'on_calendar',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            value: Number(this.checkFilterValueSaved('on_calendar')),
                                            active: Number(this.checkFilterValueSaved('on_calendar')) !== 0
                                        },
                                        {
                                            columnName: 'Tags',
                                            column_id: 'Labels',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.quizListSearchable.labels,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Labels'),
                                            active: this.checkFilterValueSaved('Labels').length > 0
                                        },
                                        {
                                            columnName: 'Companies',
                                            column_id: 'Companies',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.quizListSearchable.companies,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Companies'),
                                            active: this.checkFilterValueSaved('Companies').length > 0
                                        },
                                        {
                                            columnName: 'Courses',
                                            column_id: 'Courses',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.quizListSearchable.courses,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Courses'),
                                            active: this.checkFilterValueSaved('Courses').length > 0
                                        },
                                        {
                                            columnName: 'Lessons',
                                            column_id: 'Lessons',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.quizListSearchable.lessons,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Lessons'),
                                            active: this.checkFilterValueSaved('Lessons').length > 0
                                        },
                                    ]}
                                />
                            </div>

                        </Grid>
                    </Grid>

                }
            />
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getQuizList: Actions.getQuizList,
        setTableSort: TableActions.setTableSort,
        setTableFilter: TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,
        resetTableFilter: TableActions.resetTableFilter,
        clearFilterStore: TableFilterActions.clearFilterStore,
        setTableFilter: TableFilterActions.saveTableFilter,
    }, dispatch);
}

function mapStateToProps({ quizApp, auth, tableSort, tableFilter }) {
    return {
        auth,
        quizList: quizApp.quizzes.quizList,
        listLoaded: quizApp.quizzes.listLoaded,
        table_sort: tableSort.table_sort,
        table_filter: tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded: tableSort.is_loaded,
        filterList: tableFilter,
        quizListLoadedAfterSave: quizApp.quizzes.quizListLoadedAfterSave,
        quizListSearchable: quizApp.quizzes.quizListSearchable
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizList)));


// WEBPACK FOOTER //
// src/main/content/quiz/QuizList.js